import { PaymentMethod } from '@stripe/stripe-js';
import {
  DocumentData,
  FirestoreDataConverter,
  QueryDocumentSnapshot,
} from '@angular/fire/firestore';

export interface Shoutout {
  id?: string;
  eventId: number;
  to: string;
  team: string;
  from: string;
  message: string;
  price: number;
  productId: string;
  paid: boolean;
  paymentIntentId: string;
  paymentMethod: string | PaymentMethod | null;
  moderated: boolean;
  announced: boolean;
  approved: boolean;
  sessionId: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export const shoutoutConverter: FirestoreDataConverter<Shoutout> = {
  toFirestore(shoutout: Shoutout): DocumentData {
    return {
      ...shoutout,
      createdAt: shoutout.createdAt?.toISOString(),
      updatedAt: shoutout.updatedAt?.toISOString(),
    };
  },
  fromFirestore(snapshot: QueryDocumentSnapshot): Shoutout {
    const data = snapshot.data();
    return {
      id: snapshot.id,
      eventId: data['eventId'],
      to: data['to'],
      team: data['team'],
      from: data['from'],
      message: data['message'],
      price: data['price'],
      productId: data['productId'],
      paid: data['paid'],
      paymentIntentId: data['paymentIntentId'],
      paymentMethod: data['paymentMethod'],
      moderated: data['moderated'],
      announced: data['announced'],
      approved: data['approved'],
      sessionId: data['sessionId'],
      createdAt: data['createdAt']
        ? new Date(data['createdAt'].seconds * 1000)
        : undefined,
      updatedAt: data['updatedAt']
        ? new Date(data['updatedAt'].seconds * 1000)
        : undefined,
    };
  },
};
